// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-wrap {
  height: 70vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}
.chat-wrap h2 {
  height: 45px;
  line-height: 45px;
}
.chat-wrap .chat-message-wrap {
  flex-grow: 1;
  overflow-y: auto;
  border-bottom: 1px solid #eee;
}
.chat-wrap .chat-message-box {
  height: 70px;
  box-sizing: border-box;
  padding: 0 5px;
}
.chat-wrap .chat-message-box > textarea {
  padding: 5px 20px;
  height: 100%;
  width: 100%;
  resize: none;
}
.chat-wrap .chat-disabled {
  height: 155px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  flex-shrink: 0;
}

.ant-modal-content,
.ant-modal-header {
  border-radius: 10px;
}

.ant-modal-title {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/feature/chat/chat.scss"],"names":[],"mappings":"AAiDA;EAGE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EAIA,eAAA;AArDF;AAsDE;EACE,YAAA;EACA,iBAAA;AApDJ;AAsDE;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;AApDJ;AAsDE;EACE,YAAA;EACA,sBAAA;EACA,cAAA;AApDJ;AAqDI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAnDN;AAsDE;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AApDJ;;AAwDA;;EAEE,mBAAA;AArDF;;AAwDA;EACE,eAAA;AArDF","sourcesContent":["// .chat-container {\n//   width: 100vw;\n//   height: 100vh;\n//   background: rgba(0,0,0,0.6);\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n//   .chat-wrap {\n//     width: 60vw;\n//     max-width: 800px;\n//     height: 80vh;\n//     background: #fff;\n//     display: flex;\n//     flex-direction: column;\n//     border-radius: 16px;\n//     box-shadow: 0 10px 20px rgba(0,0,0,0.5);\n//     box-sizing: border-box;\n//     padding: 20px 0;\n//     h2{\n//       height: 45px;\n//       line-height: 45px;\n//     }\n//     .chat-message-wrap {\n//       flex-grow: 1;\n//       overflow-y: auto;\n//       border-bottom: 1px solid #eee;\n//     }\n//     .chat-message-box {\n//       height: 100px;\n//       box-sizing: border-box;\n//       padding: 0 5px;\n//       >textarea {\n//         padding: 5px 20px;\n//         height: 100%;\n//         width: 100%;\n//         resize: none;\n//       }\n//     }\n//   }\n//   .chat-disabled {\n//     height: 155px;\n//     display: flex;\n//     justify-content: center;\n//     align-items: center;\n//     font-size: 18px;\n//     flex-shrink: 0;\n//   }\n// }\n\n.chat-wrap {\n  // width: 60vw;\n  // max-width: 800px;\n  height: 70vh;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  // border-radius: 16px;\n  // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);\n  // box-sizing: border-box;\n  padding: 20px 0;\n  h2 {\n    height: 45px;\n    line-height: 45px;\n  }\n  .chat-message-wrap {\n    flex-grow: 1;\n    overflow-y: auto;\n    border-bottom: 1px solid #eee;\n  }\n  .chat-message-box {\n    height: 70px;\n    box-sizing: border-box;\n    padding: 0 5px;\n    > textarea {\n      padding: 5px 20px;\n      height: 100%;\n      width: 100%;\n      resize: none;\n    }\n  }\n  .chat-disabled {\n    height: 155px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    flex-shrink: 0;\n  }\n}\n\n.ant-modal-content,\n.ant-modal-header {\n  border-radius: 10px;\n}\n\n.ant-modal-title {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
